module.exports = __webpack_public_path__ + "static/media/istana.5f06dc24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/istana.jpg
// module id = 1603
// module chunks = 0